import { object, string } from 'yup';

import { validateLatitude, validateLongitude } from '@utils/validation';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_50_LENGTH, MAX_70_LENGTH } from '@constants/validationMessages';

export const baseSchema = {
	siteId: string()
		.max(MAX_50_LENGTH, getMaxLengthErrMsg('Site ID', MAX_50_LENGTH))
		.required(validationErrMessages.siteId),
	siteType: object()
		.shape({
			value: string()
				.max(MAX_70_LENGTH, getMaxLengthErrMsg('Site type', MAX_50_LENGTH))
				.required(validationErrMessages.siteType),
		})
		.nullable()
		.required(validationErrMessages.siteType),
	vendor: object()
		.nullable()
		.required(validationErrMessages.vendor),
};

export const addSchema = object({
	...baseSchema,
	lat: string()
		.trim()
		.test('validateLatlonCoords', validationErrMessages.latValid, validateLatitude)
		.nullable(),
	lng: string()
		.trim()
		.test('validateLatlonCoords', validationErrMessages.lngValid, validateLongitude)
		.nullable(),
});

export const editSchema = object({
	...baseSchema,
	lat: string()
		.trim()
		.test('validateLatlonCoords', validationErrMessages.latValid, validateLatitude)
		.required(validationErrMessages.coords),
	lng: string()
		.trim()
		.test('validateLatlonCoords', validationErrMessages.lngValid, validateLongitude)
		.required(validationErrMessages.coords),
});
